import { Link, useLocation } from "react-router-dom";
import logo from "./circular_logo.jpg";
import "./Navbar.css";
const Navbar = () => {
  const location = useLocation();
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <Link className="navbar-brand text-white" to="/">
          <img className="nav-log" src={logo} alt="Logo" />
          <h2 className="text-white text-capitalize">
            <span className="line-1">
              Shine International School<span class="comma">,</span>
            </span>
            <span className="line-2"> Jamudag, Ranchi</span>
          </h2>
        </Link>
        <button
          className="navbar-toggler bg-secondary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/" ? "text-success" : "text-white"
                }`}
                to="/"
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/team" ? "text-success" : "text-white"
                }`}
                to="/team"
              >
                Our Team
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/admission"
                    ? "text-success"
                    : "text-white"
                }`}
                to="/admission"
              >
                Admissions
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/gallery"
                    ? "text-success"
                    : "text-white"
                }`}
                to="/gallery"
              >
                Gallery
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/contact"
                    ? "text-success"
                    : "text-white"
                }`}
                to="/contact"
              >
                Contact Us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/erp" ? "text-success" : "text-white"
                }`}
                to="/erp"
              >
                School ERP
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
